import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  type FirestoreAssignmentRubric,
  empty,
} from '../firestore/AssignmentRubric/schema'

export class AssignmentRubric extends ObservableModelWithDecorators<FirestoreAssignmentRubric> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreAssignmentRubric>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }
}
